<!--
 * @Description: 方便禁用内部组件
 * @Date: 2024-02-22 13:26:45
-->
<template>
  <BaseForm class="bi-form" :disabled="disabled">
    <slot :disabled="disabled"></slot>
  </BaseForm>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { BaseForm } from 'xrk-components';
import { useRouteQuery } from '@V/bi-tmpl/src/hooks';
import { useBiTmplDetailSteup } from '@V/bi-tmpl/src/store';
import { storeToRefs } from 'pinia';

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const { isCheck } = useRouteQuery();

// 查看与不展示禁止操作。主题菜单101除了查看，其他情况必选
const disabled = computed(() => {
  return (
    isCheck ||
    (state.value.activeMenu[0] !== '101' && !state.value.curMenu.show)
  );
});
</script>
<style lang="scss" scoped>
.xrk-form {
  display: block !important;
}
</style>
